<template>
  <div v-if="column.field != null" class="px-1" :class="$attrs.class">
    <PaymentTitleElement
      v-if="column.type === 'title'"
      class="flex-column flex truncate dark:border-white dark:bg-slate-700 dark:text-gray-300"
      :column="column"
      :payment="payment"
    />
    <div v-else-if="column.type === 'avatar'" class="flex justify-center px-1">
      <UserAvatarPopover
        v-if="['recipient_id'].includes(column.field)"
        :user-id="payment[column.field]"
      />
      <FuneralHomeAvatar
        v-else-if="['mainInvoice#funeral_home_id'].includes(column.field)"
        :id="payment[column.field]"
      />
      <img
        v-else
        class="mx-auto h-8 w-8 rounded-full shadow-md ring-2 ring-white"
        :src="payment[column.field]"
        alt="##"
      />
    </div>

    <DateTimeFormatter
      v-else-if="column.type === 'date'"
      :date-time="payment[column.field]"
      format="DD MMM YYYY[</br>]HH:mm"
      classes="text-xs font-medium leading-4 dark:border-slate-300 dark:bg-slate-700 dark:text-gray-300 truncate"
    />
    <AmountFormatter
      v-else-if="
        column.type === 'currency' || column.type === 'currency_invoicing'
      "
      :amount="payment[column.field]"
      class="truncate leading-4 font-medium dark:border-slate-300 dark:bg-slate-700 dark:text-gray-300"
      :class="$attrs.class"
    />
    <div v-else-if="column.type === 'label'" class="flex justify-center">
      <div v-if="column.field === 'tier_payant' && payment[column.field] == 1">
        <span
          class="flex w-24 items-center gap-1 rounded bg-red-200 px-2 pl-1 text-xs text-red-800"
        >
          <FontAwesomeIcon :icon="['fal', 'receipt']" fixed-width />
          <span class="text-xs leading-normal">
            {{ $t('global.third_payment') }}
          </span>
        </span>
      </div>
      <BaseLabel
        v-else-if="
          column.field !== 'tier_payant' && payment[column.field] != null
        "
        :icon="column.field ? column.field.icon : null"
        :content="column.field ? payment[column.field]?.value : null"
        :color="column.field ? payment[column.field]?.color : null"
      />
    </div>
    <div
      v-else-if="column.type === 'text'"
      class="truncate dark:border-slate-300 dark:bg-slate-700 dark:text-gray-300"
      v-text="payment[column.field]"
    />
    <template
      v-else-if="column.type === 'link' && payment[column.field] != null"
    >
      <RouterLink
        v-if="payment[column.field].router"
        :to="payment[column.field].router"
        class="text-primary truncate font-semibold"
      >
        {{ payment[column.field]?.label ?? $t('button.navigate') }}
      </RouterLink>
      <div
        v-else
        class="truncate dark:border-slate-300 dark:bg-slate-700 dark:text-gray-300"
        v-text="payment[column.field]?.label"
      />
    </template>
  </div>
</template>
<script>
import DateTimeFormatter from '@c/DateTimeFormatter'
import BaseLabel from '@c/addf-package/components/BaseLabel/BaseLabel.vue'
import AmountFormatter from '@c/AmountFormatter.vue'
import FuneralHomeAvatar from '@c/Avatar/FuneralHomeAvatar.vue'
import UserAvatarPopover from '@c/Avatar/Popover/UserAvatarPopover.vue'
import PaymentTitleElement from '@c/Dashboard/Content/Payment/components/paymentTitleElement.vue'

export default {
  name: 'PaymentRowElement',
  components: {
    PaymentTitleElement,
    UserAvatarPopover,
    FuneralHomeAvatar,
    AmountFormatter,
    BaseLabel,
    DateTimeFormatter
  },
  props: {
    column: { type: Object, required: true },
    payment: { type: Object, required: true }
  }
}
</script>
